// Thin, quiet client for the SOC contract. Never throws: every call resolves
// {status, data}; status 0 = network failure. 404/501 (backend not restarted
// yet) just look like "unavailable" to callers, who hide their UI.
const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

export const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function socialFetch(path, { method = 'GET', body, signal } = {}) {
  try {
    const res = await fetch(`${API_BASE}${path}`, {
      method, signal,
      headers: { ...authHeaders(), ...(body ? { 'Content-Type': 'application/json' } : {}) },
      body: body ? JSON.stringify(body) : undefined,
    });
    let data = null;
    try { data = await res.json(); } catch { /* empty body */ }
    return { status: res.status, ok: res.ok, data };
  } catch (e) {
    return { status: 0, ok: false, data: null, aborted: e && e.name === 'AbortError' };
  }
}

export const isUnavailable = (r) => !r || r.status === 0 || r.status === 404 || r.status === 501 || r.status >= 500;

// ── profile cache (hover cards + profile page share it) ──
const PROFILE_TTL = 60000;
const profiles = new Map();

export function clearProfileCache() { profiles.clear(); }

export function patchCachedProfile(handle, patch) {
  const hit = profiles.get(String(handle).toLowerCase());
  if (hit && hit.result && hit.result.data) hit.result = { ...hit.result, data: { ...hit.result.data, ...patch } };
}

/** GET /api/u/<handle>, following one {redirect}. Cached for a minute. */
export function loadProfile(handle, { force = false } = {}) {
  const key = String(handle || '').toLowerCase().replace(/^@/, '');
  const hit = profiles.get(key);
  if (!force && hit && Date.now() - hit.ts < PROFILE_TTL) return hit.promise || Promise.resolve(hit.result);
  const promise = (async () => {
    let r = await socialFetch(`/api/u/${encodeURIComponent(key)}`);
    if (r.ok && r.data && r.data.redirect) r = await socialFetch(`/api/u/${encodeURIComponent(r.data.redirect)}`);
    return r;
  })();
  const entry = { ts: Date.now(), promise, result: null };
  profiles.set(key, entry);
  promise.then((r) => {
    entry.result = r; entry.promise = null;
    if (!r.ok && r.status !== 403) profiles.delete(key); // don't cache transient failures
  });
  return promise;
}
